import axios from "axios";
import axiosRetry from "axios-retry";

const ApiInstance = axios.create({
    baseURL: "https://admin.capexfinancialservices.org/api/",
    timeout: 30 * 1000, // thirty seconds timer
    headers: {
        'Content-Type': 'application/json',
    },
});

const retryDelay = (retryNumber = 0) => {
    const seconds = Math.pow(2, retryNumber) * 1000;
    const randomMs = 1000 * Math.random();
    return seconds + randomMs;
};

axiosRetry(ApiInstance, {
    retries: 2,
    retryDelay,
    // retry on Network Error & 5xx responses
    retryCondition: axiosRetry.isRetryableError,
});


ApiInstance.interceptors.request.use((request) => {
    const allowedCorsHeaders = [
        'Common', 'Delete', 'Get', 'Head',
        'Post', 'Put', 'Patch', 'Origin',
        'X-Requested-With', 'Content-Type', 'Accept',
    ].map((header) => header.toLowerCase());
    // Get the headers we are sending in the requests
    const headers = Object.keys(request.headers).map((header) => header.toLowerCase());
    // Get the headers to send are not in the allowed list
    const invalidHeaders = headers.filter((header) => !allowedCorsHeaders.includes(header));
    if (invalidHeaders.length > 0) {
        const msg = `Header(s): ${invalidHeaders.join(', ')} are not allowed!`;
        console.log(msg);
    }
    return request;
});

export default ApiInstance;